module.exports = __webpack_public_path__ + "static/img/icon5-7.43a0159b.png";